import api from "./api";

// Lista todos os usuários cadastrados
// Endpoint: GET /api/usuario/getAll
export const getAllUsuarios = () => api.get("/api/usuario/getAll");

// Busca os dados de um usuário por ID
// Endpoint: GET /api/usuario/getById/{id}
export const getUsuarioById = (id) => {
  return api.get(`/api/usuario/getById/${id}`);
};

// Atualiza os dados do perfil do usuário
// Endpoint: PATCH /api/usuario/updatePerfil
export const updatePerfilUsuario = (payload) =>
  api.patch("/api/usuario/updatePerfil", payload);

// Ativa ou inativa um usuário
// Endpoint: PATCH /api/usuario/disable
export const toggleUsuarioAtivo = ({ id, ativo }) =>
  api.patch("/api/usuario/disable", { id, ativo });

// Busca todos os usuários cadastrados e retorna uma lista simplificada
// Endpoint: GET /api/usuario/getAll
export const fetchAllUsuarios = async () => {
  try {
    const response = await api.get("/api/usuario/getAll");
    if (response.data && response.data.usuarios) {
      return response.data.usuarios.map((u) => ({
        id: u.id,
        name: u.nome,
        email: u.email,
        idPerfil: u.idPerfil,
      }));
    }
    return [];
  } catch (error) {
    return [];
  }
};
